import { ActionButtonComponent } from '@shared/action-button/action-button.component';
import { RouterLinkButtonComponent } from '@shared/action-button/router-link-button.component';
import { IconButtonComponent } from '@shared/action-button/icon-button.component';
import { LinkButtonComponent } from '@shared/action-button/link-button.component';

export const buttonComponents = [
  ActionButtonComponent,
  LinkButtonComponent,
  RouterLinkButtonComponent,
  IconButtonComponent,
];
